import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Flex } from 'foundations-components/components/Flex';
import styled from 'foundations-theming/utils';
import { trellisBreakpoint } from 'pricing-pages-ui-components/constants/Breakpoints';
import { PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import { useDisplayedCurrencyCode } from '../../hooks/useCurrencies';
import ProductIcon from '../common/ProductIcon';
import { InterstitialTileTitle } from './SharedComponents';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TitleContainer = styled.div.withConfig({
  displayName: "InterstitialSeatsTile__TitleContainer",
  componentId: "sc-1i0u26u-0"
})(({
  theme
}) => {
  return {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'end',
    marginBlockEnd: theme.space[300],
    flexDirection: 'row',
    [trellisBreakpoint.phone]: {
      flexDirection: 'column',
      alignItems: 'start'
    }
  };
});
export const InterstitialSeatsTile = ({
  productLine,
  price,
  title,
  description,
  children
}) => {
  const currencyCode = useDisplayedCurrencyCode();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        children: [/*#__PURE__*/_jsx(TitleContainer, {
          children: /*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            children: [/*#__PURE__*/_jsx(ProductIcon, {
              name: productLine,
              iconStyle: {
                marginBlockEnd: '100',
                marginInlineEnd: '200',
                inlineSize: '24px'
              }
            }), /*#__PURE__*/_jsx(View, {
              marginBlockEnd: "0",
              children: /*#__PURE__*/_jsx(InterstitialTileTitle, {
                children: title
              })
            })]
          })
        }), description && /*#__PURE__*/_jsx("div", {
          style: {
            maxWidth: '55ch'
          },
          children: description
        }), /*#__PURE__*/_jsx(View, {
          marginBlockEnd: "400",
          as: "div",
          children: /*#__PURE__*/_jsx(Flex, {
            flexDirection: "column",
            children: /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "planBuilder.priceDisplay.perMonthPerSeat",
              options: {
                price: /*#__PURE__*/_jsx(PriceDisplay, {
                  price: price,
                  currencyCode: currencyCode
                })
              }
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        inlineSize: "100px",
        children: children
      })]
    })
  });
};